<div class="monospaced">
  <app-copy-button class="monospaced__button" [value]="content.textContent"></app-copy-button>
  <pre class="monospaced__pre" #content><ng-content></ng-content></pre>
</div>
